<template>
  <validation-observer v-slot="{ invalid }">
    <v-form class="form" ref="form" lazy-validation>
      <div class="ml-16 mr-16 pl-16 pr-16">
        <div class="text-align-left pt-16 pl-16 pr-16 pa-4 mb-14">
          <question-title :question_title="formValues_a.title"></question-title>
          <check-box :name_property="formValues_a.nameProperty" :name_property_other="formValues_a.namePropertyOther" :datas="formValues_a"></check-box>
          <question-title :question_title="formValues_b.title" :required_mark="formValues_b.requiredMark"></question-title>
          <radio-box :name_property="formValues_b.nameProperty" :datas="formValues_b"></radio-box>
          <question-title :question_title="formValues_c.title"></question-title>
          <check-box :name_property="formValues_c.nameProperty" :name_property_other="formValues_c.namePropertyOther" :datas="formValues_c"></check-box>
          <question-title :question_title="formValues_d.title"></question-title>
          <field-area :name_property="formValues_d.nameProperty" :datas="formValues_d"></field-area>
          <question-title :question_title="formValues_e.title"></question-title>
          <field-area :name_property="formValues_e.nameProperty" :datas="formValues_e"></field-area>
          <question-title class="ml-4" :question_title="formValues_f.title" :required_mark="formValues_f.requiredMark"></question-title>
          <radio-box :displayFlg="radioTextDisplay" :name_property="formValues_f.nameProperty" :name_property_other="formValues_f.namePropertyOther" :datas="formValues_f"></radio-box>
          <question-title class="ml-4" :question_title="formValues_g.title" :required_mark="formValues_g.requiredMark"></question-title>
          <radio-box :name_property="formValues_g.nameProperty" :datas="formValues_g"></radio-box>

          <v-divider class="my-8"></v-divider>
          <v-card-actions justify="space-between" class="mx-auto">
            <tool-button class="mx-auto" link="/" text="戻る"></tool-button>
            <v-spacer></v-spacer>
              <v-btn id="submitButton" :disabled="invalid" color="primary" large  text-align="center" @click="submit()">送信</v-btn>
          </v-card-actions>
        </div>
      </div>
    </v-form>
  </validation-observer>
</template>

<script>
import QuestionTitle from '@/components/QuestionTitle.vue'
import CheckBox from '@/components/CheckBox.vue'
import RadioBox from '@/components/RadioBox.vue'
import FieldArea from '@/components/FieldArea.vue'
import ToolButton from '@/components/ToolButton.vue'
import axios from 'axios'

export default {
  name: 'Home',
  components: {
    QuestionTitle,
    CheckBox,
    RadioBox,
    FieldArea,
    ToolButton
  },
  data () {
    return {
      invalid: false,
      radioTextDisplay: true
    }
  },
  computed: {
    formValues_a: {
      get () {
        return this.$store.state.formValues_a
      },
      set (value) {
        this.$store.commit('setFormValues_a', { formValues_a: value })
      }
    },
    formValues_b: {
      get () {
        return this.$store.state.formValues_b
      },
      set (value) {
        this.$store.commit('setFormValues_b', { formValues_b: value })
      }
    },
    formValues_c: {
      get () {
        return this.$store.state.formValues_c
      },
      set (value) {
        this.$store.commit('setFormValues_c', { formValues_c: value })
      }
    },
    formValues_d: {
      get () {
        return this.$store.state.formValues_d
      },
      set (value) {
        this.$store.commit('setFormValues_d', { formValues_d: value })
      }
    },
    formValues_e: {
      get () {
        return this.$store.state.formValues_e
      },
      set (value) {
        this.$store.commit('setFormValues_e', { formValues_e: value })
      }
    },
    formValues_f: {
      get () {
        return this.$store.state.formValues_f
      },
      set (value) {
        this.$store.commit('setFormValues_f', { formValues_f: value })
      }
    },
    formValues_g: {
      get () {
        return this.$store.state.formValues_g
      },
      set (value) {
        this.$store.commit('setFormValues_g', { formValues_g: value })
      }
    },
    formValue_host: {
      get () {
        return this.$store.state.formValues_host
      },
      set (value) {
        this.$store.commit('setFormValues_host', { formValues_host: value })
      }
    },
    hostGet () {
      const hostname = location.hostname
      return hostname
    }
  },
  methods: {
    // clear: function () {
    //   this.$router.go({ path: this.$router.currentRoute.path, force: true })
    // },
    submit: function () {
      if (this.$refs.form.validate()) {
        const formData = new FormData()
        for (const i in this.$store.state.formValues_a.saveValue) {
          formData.append(this.$store.state.formValues_a.nameProperty, this.$store.state.formValues_a.saveValue[i])
        }
        formData.append(this.$store.state.formValues_a.namePropertyOther, this.$store.state.formValues_a.saveValueOther)
        formData.append(this.$store.state.formValues_b.nameProperty, this.$store.state.formValues_b.saveValue)
        for (const i in this.$store.state.formValues_c.saveValue) {
          formData.append(this.$store.state.formValues_c.nameProperty, this.$store.state.formValues_c.saveValue[i])
        }
        formData.append(this.$store.state.formValues_c.namePropertyOther, this.$store.state.formValues_c.saveValueOther)
        formData.append(this.$store.state.formValues_d.nameProperty, this.$store.state.formValues_d.saveValue)
        formData.append(this.$store.state.formValues_e.nameProperty, this.$store.state.formValues_e.saveValue)
        formData.append(this.$store.state.formValues_f.nameProperty, this.$store.state.formValues_f.saveValue)
        formData.append(this.$store.state.formValues_f.namePropertyOther, this.$store.state.formValues_f.saveValueOther)
        formData.append(this.$store.state.formValues_g.nameProperty, this.$store.state.formValues_g.saveValue)
        formData.append(this.$store.state.formValues_host.nameProperty, this.hostGet)

        for (var [key, value] of formData.entries()) {
          console.log(key, value)
        }

        // const GOOGLE_FORM_ACTION = 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSd58ooIN_DUIFbJT3zdADDwrJdzu70Id1XiNIbVKCmAYZWPig/formResponse'
        const GOOGLE_FORM_ACTION = 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSco0yLipXJ5mHjo7oOxWN3Teo9DncCy88PyZnqJHQL85q5PGg/formResponse'
        axios.post(GOOGLE_FORM_ACTION, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then((res) => {
            for (var [key, value] of formData.entries()) {
              console.log(key, value)
            }
            this.$router.push('/appreciate')
          }).catch((err) => {
            console.log(err)
            this.$router.push('/appreciate')
          })
      }
    }
  }
}
</script>
